import './setPublicPath';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';

import App from './components/App';
import apolloClient from './graphql/client';

const init = () => {
  const container = document.querySelector('.bombas-application');
  const root = createRoot(container);
  const allConfig = [
    ...document.querySelectorAll('script[data-component]')
  ].reduce((final, cfg) => {
    let parsed = {};

    try {
      parsed = JSON.parse(cfg.innerHTML);
    } catch (_e) {
      window.DD_RUM?.addError(
        new Error(
          `Unable to parse configuration for '${cfg.dataset.component}' component.`
        ),
        { location: 'app' }
      );
    }

    return {
      ...final,
      [cfg.dataset.component]: parsed
    };
  }, {});

  if (container) {
    root.render(
      <ApolloProvider client={apolloClient}>
        <App {...allConfig} />
      </ApolloProvider>
    );
  }
};

export default init();
